import loumIcon from '@/assets/clients/loum.png';
import onuhIcon from '@/assets/clients/onuh.png';
import greenIsGoodIcon from '@/assets/clients/green-is-good.png';
import hivenIcon from '@/assets/clients/hiven.png';
import donaRicaIcon from '@/assets/clients/dona-rica.png';

/** How many notifications the auth lock screen shows at once. */
export const PUSH_STACK_SIZE = 3;

/**
 * Longest title that fits beside "há 5 min" (157px at 13px semibold, measured
 * in SF, Arial and Segoe UI); 20 characters land around 127px.
 */
export const TITLE_MAX_LENGTH = 20;

// Real Korza clients' pushes, from the push demo of korza.com.br
// (`pushExamples` in its app.js), so the copy stays in Portuguese in every
// locale. Bodies are the site's; titles are shortened versions, since the
// site's ones overflow the title line on this 300px phone next to "há 5 min"
// (keep new ones within TITLE_MAX_LENGTH).
//
// Order differs from the site on purpose: the stack shows PUSH_STACK_SIZE
// consecutive entries (cyclically), so Loum's two pushes sit that far apart
// and the lock screen never shows the same store twice.
export const PUSH_EXAMPLES = [
  {
    brand: 'Loum',
    icon: loumIcon,
    title: 'Seu novo favorito 🤎',
    body: 'A coleção nova já está no app.',
  },
  {
    brand: 'Onuh',
    icon: onuhIcon,
    title: 'Pedido a caminho',
    body: 'A ansiedade é sua. O cuidado é nosso.',
  },
  {
    brand: 'Green is Good',
    icon: greenIsGoodIcon,
    title: 'Hora de se cuidar 🌿',
    body: 'Seus favoritos estão por aqui.',
  },
  {
    brand: 'Loum',
    icon: loumIcon,
    title: 'Seu carrinho espera',
    body: 'Seu próximo look ficou te esperando.',
  },
  {
    brand: 'Hiven',
    icon: hivenIcon,
    title: 'De volta ao estoque',
    body: 'A peça que você queria. No seu tamanho.',
  },
  {
    brand: 'Dona Rica',
    icon: donaRicaIcon,
    title: 'Novidade pra você',
    body: 'Sua próxima escolha está no app.',
  },
] as const;
